import { useEffect } from 'react';
import { useForm } from 'react-form-state-manager';
import { useTranslation } from 'react-i18next';

import { ParticipantFieldType } from '__generated__/graphql';

import {
  ParticipantField, ParticipantFieldEntryInput,
} from '../../../../../common/ParticipantFields/ParticipantFieldInputProps';
import ParticipantFieldConfigFormProps from './ParticipantFieldConfigFormProps';
import TimeInput from '../../../../../common/ParticipantFields/Types/TimeInput';
import UI from '../../../../../common/UI';

interface Config {
  min: number | null;
  max: number | null;
}

interface TimeConfigFormProps extends ParticipantFieldConfigFormProps {
  config: Config | null;
}

const TimeConfigForm = ({ config, onChange }: TimeConfigFormProps) => {
  const { t } = useTranslation();

  const min = config?.min;
  const max = config?.max;

  const minField: ParticipantField = {
    type: ParticipantFieldType.time,
    id: 'min',
    title: t('minimum'),
    enabled_choices: [],
    config: null,
    has_external_validation: false,
  };

  const maxField: ParticipantField = {
    type: ParticipantFieldType.time,
    id: 'max',
    title: t('maximum'),
    enabled_choices: [],
    config: null,
    has_external_validation: false,
  };

  const form = useForm<{ min: ParticipantFieldEntryInput; max: ParticipantFieldEntryInput; }>({
    values: {
      min: { value: min ? min.toString() : null },
      max: { value: max ? max.toString() : null },
    },
  });

  useEffect(() => {
    onChange({
      min: form.values.min.value ? parseInt(form.values.min.value, 10) : null,
      max: form.values.max.value ? parseInt(form.values.max.value, 10) : null,
    });
  }, [form.values.min.value, form.values.max.value]);

  return (
    <>
      <UI.InputGroup>
        <UI.InputLabel>
          {t('range')}
        </UI.InputLabel>
        <UI.InputDescription>
          {t('time_field.range_description')}
        </UI.InputDescription>
      </UI.InputGroup>

      <UI.InputGroup>
        <TimeInput
          value={form.values.min}
          onChange={(fieldEntry) => form.set((values) => ({ ...values, min: fieldEntry }))}
          field={minField}
        />
      </UI.InputGroup>

      <UI.InputGroup>
        <TimeInput
          value={form.values.max}
          onChange={(fieldEntry) => form.set((values) => ({ ...values, max: fieldEntry }))}
          field={maxField}
        />
      </UI.InputGroup>
    </>
  );
};

export default TimeConfigForm;
